import { render, staticRenderFns } from "./createPEA.vue?vue&type=template&id=01df6924&scoped=true"
import script from "./createPEA.vue?vue&type=script&lang=js"
export * from "./createPEA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01df6924",
  null
  
)

export default component.exports